/**
 * FT8-U17: Dunning Effectiveness (FSD 2.2.3.10 — response and recovery rate by dunning
 * stage and channel). The INT packet spreads `AR_DUNNING_EFFECTIVENESS_ROUTES` and adds
 * the nav item. The route's permission is the report endpoint's: `ar.dunning.read`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AR_PERMISSIONS } from '@/modules/ar/permissions'

export const AR_DUNNING_EFFECTIVENESS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ar/reports/dunning-effectiveness',
    name: 'ar-dunning-effectiveness',
    component: () => import('@/modules/ar/reports/dunning-effectiveness/DunningEffectivenessView.vue'),
    meta: {
      titleKey: 'ar.routeTitles.dunningEffectiveness',
      permission: AR_PERMISSIONS.dunningRead,
    },
  },
]
